<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import TagsView from './TagsView.vue'
import { UserOutlined, SettingOutlined, LogoutOutlined, SafetyCertificateOutlined } from '@ant-design/icons-vue'
import { edit_user, sendSmsCode as sendSmsCodeApi } from '@/api/user'
const router = useRouter()

const { proxy } = getCurrentInstance();
const $socket = proxy.$socket;

// 标签页数据
const activeTab = ref('赛事管理')
const tabs = ref([
  { key: '赛事管理', label: '赛事管理', closable: true }
])

// 用户信息
const userInfo = ref({
  name: '用户',
  phone: '',
  sms_code: ''
})

const chargeVisible = ref(false);
const smsLoading = ref(false)
const countdown = ref(0)

// 初始化用户信息
onMounted(() => {
  const storedUserInfo = localStorage.getItem('userInfo')
  if (storedUserInfo) {
    try {
      const parsed = JSON.parse(storedUserInfo)
      userInfo.value = {
        name: parsed.name || parsed.phone || '用户',
        phone: parsed.phone || '',
        sms_code: ''
      }
    } catch (error) {
      console.error('解析用户信息失败:', error)
    }
  }
})

// 处理退出登录
function handleLogout() {
  // user_logout().then(res => {
  //   if (res.code === 200) {
  //     message.success('退出登录成功')
  //     router.push('/login')
  //     // 清除本地存储的认证信息
  //     localStorage.removeItem('token')
  //     localStorage.removeItem('userInfo')
  //     localStorage.removeItem('userLoginInfo')
  //   } else {
  //     message.error(res.message || '退出登录失败')
  //   }
  // })
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('userLoginInfo')

  message.success('已退出登录')

  // 跳转到登录页
  router.push('/login')

  $socket && $socket.disconnect();
}

// 下拉菜单项
const dropdownItems = [
  {
    key: 'profile',
    label: '个人中心',
    icon: '👤'
  },
  {
    key: 'settings',
    label: '设置',
    icon: '⚙️'
  },
  {
    type: 'divider'
  },
  {
    key: 'logout',
    label: '退出登录',
    icon: '🚪',
    onClick: handleLogout
  }
]

function handleMenuClick(key) {
  if (key.key === 'logout') {
    handleLogout()
  } else if(key.key === 'settings') {
    chargeVisible.value = true
  }
}

function saveCharge() {
  if(!userInfo.value.name) {
    message.warning('请输入姓名')
    return
  }
  
  if(!userInfo.value.phone) {
    message.warning('请输入手机号')
    return
  }

  if(!userInfo.value.sms_code) {
    message.warning('请输入验证码')
    return
  }

  edit_user({
    username: userInfo.value.name,
    phone: userInfo.value.phone,
    sms_code: userInfo.value.sms_code
  }).then(res => {
    localStorage.setItem('userInfo', JSON.stringify(userInfo.value))
    chargeVisible.value = false
  })
}

function cancelEditCharge() {
  const storedUserInfo = localStorage.getItem('userInfo')
  if (storedUserInfo) {
    const parsed = JSON.parse(storedUserInfo)
    userInfo.value = {
      name: parsed.name || parsed.phone || '用户',
      phone: parsed.phone || '',
      sms_code: ''
    }
  }
  chargeVisible.value = false
}

// 是否可以发送短信
const canSendSms = computed(() => {
  return /^1[3-9]\d{9}$/.test(userInfo.value.phone)
})

// 发送短信验证码
const sendSmsCode = async () => {
  if (!canSendSms.value) {
    message.warning('请输入正确的手机号')
    return
  }

  try {
    smsLoading.value = true
    await sendSmsCodeApi({ phone: userInfo.value.phone, type: 'editMyInfo' })
    message.success('验证码已发送')
    startCountdown()
  } catch (error) {
    // message.error(error.message || '发送失败，请重试')
  } finally {
    smsLoading.value = false
  }
}

// 开始倒计时
const startCountdown = () => {
  countdown.value = 60
  const timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}
</script>

<template>
  <div class="header">
    <div class="left">
      <TagsView />
    </div>

    <div class="right">

      <a-dropdown :menu="{ items: dropdownItems }" placement="bottomRight">
        <div class="user-info">
          <!-- <img :src="userInfo.avatar" :alt="userInfo.name" class="avatar" /> -->
          <span class="username">{{ userInfo.name }}</span>
        </div>
        <template #overlay>
          <a-menu @click="handleMenuClick">
            <!-- <a-menu-item key="profile">
              <template #icon>
                <UserOutlined />
              </template>
个人中心
</a-menu-item> -->
            <a-menu-item key="settings">
              <template #icon>
                <SettingOutlined />
              </template>
              设置
            </a-menu-item>
            <a-menu-item key="logout">
              <template #icon>
                <LogoutOutlined />
              </template>
              退出登录
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <a-modal v-model:open="chargeVisible" title="赛事负责人" :footer="null" width="520px">
      <div style="padding: 12px 0;">
        <div style="display:flex; align-items:center; gap:12px; margin-bottom: 16px;">
          <span style="width: 72px; text-align:right; color:#666;">姓名：</span>
          <a-input v-model:value="userInfo.name" style="width: 260px" />
        </div>
        <div style="display:flex; align-items:center; gap:12px;  margin-bottom: 16px;">
          <span style="width: 72px; text-align:right; color:#666;">手机号：</span>
          <a-input v-model:value="userInfo.phone" style="width: 260px" />
        </div>
        <div style="display:flex; align-items:center; gap:12px;">
          <span style="width: 72px; text-align:right; color:#666;">验证码：</span>
          <a-input-group compact style="width: 260px">
            <a-input v-model:value="userInfo.sms_code" placeholder="请输入验证码" :maxlength="6" style="width: 140px">
              <template #prefix>
                <SafetyCertificateOutlined />
              </template>
            </a-input>
            <a-button :disabled="!canSendSms || countdown > 0" :loading="smsLoading" @click="sendSmsCode"
              style="width: 120px">
              {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
            </a-button>
          </a-input-group>
        </div>
        <div style="text-align:center; margin-top: 20px;">
          <a-button type="primary" @click="saveCharge">保存</a-button>
          <a-button style="margin-left: 12px;" @click="cancelEditCharge">取消</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<style scoped>
.header {
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
}

.left {
  flex: 1;
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tabs {
  width: 100%;
}

:deep(.ant-tabs-nav) {
  margin: 0;
}

:deep(.ant-tabs-tab) {
  padding: 8px 16px;
  margin: 0 4px 0 0;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  background: #fff;
}

:deep(.ant-tabs-tab-active) {
  border-color: #1677ff;
  color: #1677ff;
}

.collapse-btn {
  padding: 4px 8px;
  border: none;
  background: transparent;
}

.collapse-icon {
  font-size: 12px;
  color: #666;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.user-info:hover {
  background-color: #f5f5f5;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.username {
  font-size: 14px;
  color: #333;
}

.dropdown-icon {
  font-size: 10px;
  color: #999;
}
</style>
